var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAvatarAnonym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 72,
    viewBox: "0 0 55 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_2687)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_669_2687)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6311 42.6185C10.7424 42.917 9.91982 43.1934 9.19431 43.4336C2.9812 45.491 0.910156 68.6786 0.910156 71.7925H27.8337V37.873C24.2962 38.3638 16.8312 40.8716 11.6311 42.6185ZM44.178 42.6185C45.0744 42.917 45.9042 43.1934 46.636 43.4336C52.9031 45.491 54.9922 68.6786 54.9922 71.7925H27.8346V37.873C31.4028 38.3638 38.9327 40.8716 44.178 42.6185Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6573 22.4711C19.6573 24.9167 17.6321 26.8993 15.1338 26.8993C12.6356 26.8993 11.7969 24.9167 11.7969 22.4711C11.7969 20.0255 12.6356 18.043 15.1338 18.043C17.6321 18.043 19.6573 20.0255 19.6573 22.4711Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6573 22.4711C19.6573 24.9167 17.6321 26.8993 15.1338 26.8993C12.6356 26.8993 11.7969 24.9167 11.7969 22.4711C11.7969 20.0255 12.6356 18.043 15.1338 18.043C17.6321 18.043 19.6573 20.0255 19.6573 22.4711Z",
    fill: "#4F4F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.122 22.4633C36.122 24.9089 38.1472 26.8915 40.6455 26.8915C43.1437 26.8915 43.9824 24.9089 43.9824 22.4633C43.9824 20.0177 43.1437 18.0352 40.6455 18.0352C38.1472 18.0352 36.122 20.0177 36.122 22.4633Z",
    fill: "#4F4F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.122 22.4633C36.122 24.9089 38.1472 26.8915 40.6455 26.8915C43.1437 26.8915 43.9824 24.9089 43.9824 22.4633C43.9824 20.0177 43.1437 18.0352 40.6455 18.0352C38.1472 18.0352 36.122 20.0177 36.122 22.4633Z",
    fill: "#4F4F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4023 31.6836H32.9323V42.6515C31.0791 44.6307 24.045 44.3833 22.4023 42.6515V31.6836Z",
    fill: "#4F4F4F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4023 31.6836H32.9323V35.2213C29.0427 37.6135 26.0725 37.3711 22.4023 35.0299V31.6836Z",
    fill: "#111111",
    fillOpacity: 0.5
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8636 17.3186C41.8636 27.9498 37.2495 34.8974 27.9035 34.8974C18.5574 34.8974 13.9434 27.9498 13.9434 17.3186C13.9434 6.68733 18.5574 0.974609 27.9035 0.974609C37.2495 0.974609 41.8636 6.68733 41.8636 17.3186Z",
    fill: "#4F4F4F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_669_2687",
    x: -14.0898,
    y: -10.0254,
    width: 84.082,
    height: 100.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_669_2687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_669_2687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_2687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.082,
    height: 70.817,
    fill: "white",
    transform: "translate(0.910156 0.974609)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.5,15) scale(0.2,0.2)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 33,
    viewBox: "0 0 94 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2876 3.0629C31.8514 7.66997 28.3173 31.0979 25.2876 31.8422C19.2294 33.3307 1.05363 36.3081 0.0439429 18.445C-0.961468 0.657638 15.5218 -3.79163 25.2876 3.0629Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C24 23.0751 23.0751 27 17 27C10.9249 27 10 23.0751 10 17C10 10.9249 10.9249 7 17 7C23.0751 7 24 10.9249 24 17Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7124 3.0629C62.1486 7.66997 65.6827 31.0979 68.7124 31.8422C74.7706 33.3307 92.9464 36.3081 93.9561 18.445C94.9615 0.657638 78.4782 -3.79163 68.7124 3.0629Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84 17C84 23.0751 83.0751 27 77 27C70.9249 27 70 23.0751 70 17C70 10.9249 70.9249 7 77 7C83.0751 7 84 10.9249 84 17Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarAnonym);
export default __webpack_public_path__ + "static/media/UserAvatarAnonym.0c1a8a92c6a3cc2540ef6e5ef2db4be4.svg";
export { ForwardRef as ReactComponent };